/**
 * Focus mode: everything but the paragraph you're writing fades back.
 * The plugin always tracks the active paragraph; CSS only dims when the
 * root <html> carries .hn-focus-mode (toggled by the command).
 */
import { Decoration, type DecorationSet, EditorView, ViewPlugin, type ViewUpdate } from "@codemirror/view";
import type { Range } from "@codemirror/state";

export const focusModeHighlight = [
  ViewPlugin.fromClass(
    class {
      decorations: DecorationSet;
      constructor(view: EditorView) {
        this.decorations = this.build(view);
      }
      update(u: ViewUpdate) {
        if (u.docChanged || u.selectionSet || u.viewportChanged) {
          this.decorations = this.build(u.view);
        }
      }
      build(view: EditorView): DecorationSet {
        const doc = view.state.doc;
        const head = view.state.selection.main.head;
        const cur = doc.lineAt(head);
        // expand to the surrounding paragraph (contiguous non-blank lines)
        let start = cur.number;
        let end = cur.number;
        while (start > 1 && doc.line(start - 1).text.trim() !== "") start--;
        while (end < doc.lines && doc.line(end + 1).text.trim() !== "") end++;
        const deco: Range<Decoration>[] = [];
        for (let n = start; n <= end; n++) {
          deco.push(Decoration.line({ class: "hn-para-active" }).range(doc.line(n).from));
        }
        return Decoration.set(deco);
      }
    },
    { decorations: (v) => v.decorations },
  ),
  EditorView.theme({
    ".cm-line": {
      transition: "opacity 160ms ease",
    },
  }),
];
